import type { TokenomicsState } from "../../shared/types";

const labels: Record<TokenomicsState, string> = {
  net_inflationary: "Net inflationary",
  crossover_watch: "Crossover watch",
  net_deflationary: "Net deflationary",
  data_incomplete: "Data incomplete",
};

export function StatusPill({ state }: { state: TokenomicsState }) {
  return <span className={`status-pill status-pill--${state}`}><span className="status-pill__dot" />{labels[state]}</span>;
}
